<div class="layout-column" [ngStyle]="style()">
    @for (column of columns(); track column.component) {
    <ng-container [dynamic]="column"></ng-container>
    }
</div>
